// Configuration centralisée de l'application
// Les URLs sont définies dans le fichier .env

// URL de base du backend
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost/djamann/backend';

// URL de l'API
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/djamann/backend/index.php/api';

// URL des uploads
export const UPLOADS_URL = `${BACKEND_URL}/uploads/`;

// Helpers pour construire les URLs des ressources
export const getUploadUrl = (path) => {
  if (!path) return null;
  // Si le chemin commence déjà par http, le retourner tel quel
  if (path.startsWith('http')) return path;
  // Si le chemin commence par uploads/, le préfixer avec BACKEND_URL
  if (path.startsWith('uploads/')) return `${BACKEND_URL}/${path}`;
  // Sinon, utiliser UPLOADS_URL
  return `${UPLOADS_URL}${path}`;
};

// URLs spécifiques pour différents types d'uploads
export const getProfilePhotoUrl = (photo) => {
  if (!photo) return null;
  if (photo.startsWith('http')) return photo;
  // Si le chemin contient déjà le dossier, utiliser BACKEND_URL
  if (photo.includes('/')) return `${BACKEND_URL}/${photo}`;
  return `${UPLOADS_URL}photos_profil/${photo}`;
};

export const getProjectImageUrl = (image) => {
  if (!image) return null;
  if (image.startsWith('http')) return image;
  return `${UPLOADS_URL}projects/${image}`;
};

export const getServiceImageUrl = (image) => {
  if (!image) return null;
  if (image.startsWith('http')) return image;
  return `${UPLOADS_URL}services/${image}`;
};

export const getLogoUrl = (logo) => {
  if (!logo) return null;
  if (logo.startsWith('http')) return logo;
  return `${UPLOADS_URL}logos/${logo}`;
};

export const getPaymentProofUrl = (proof) => {
  if (!proof) return null;
  if (proof.startsWith('http')) return proof;
  return `${UPLOADS_URL}payment_proofs/${proof}`;
};

export const getPaymentQrImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  if (path.startsWith('uploads/')) return `${BACKEND_URL}/${path}`;
  return `${UPLOADS_URL}payment_qr/${path}`;
};

export const getIdentityDocUrl = (doc) => {
  if (!doc) return null;
  if (doc.startsWith('http')) return doc;
  if (doc.includes('/')) return `${BACKEND_URL}/${doc}`;
  return `${UPLOADS_URL}${doc}`;
};

const config = {
  BACKEND_URL,
  API_URL,
  UPLOADS_URL,
  getUploadUrl,
  getProfilePhotoUrl,
  getProjectImageUrl,
  getServiceImageUrl,
  getLogoUrl,
  getPaymentProofUrl,
  getIdentityDocUrl
};

export default config;
